import { Form, Modal, Select, message } from "antd";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { ApiService } from "../api";
import { OptionProps } from "antd/es/select";
import { debounce } from "lodash";
import { openNotificationWithIcon } from "../constants";

type Props = {
  requestId: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  fetch: number;
  setFetch: (fetch: number) => void;
};

const HandoverModal = (props: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [users, setUsers] = useState<OptionProps[]>([]);

  const handleUserSearch = async (value: string) => {
    const result = (await ApiService.apiAccountsUsersList(value)).map((x) => ({
      value: x.id,
      label: x.name,
      children: null,
    }));
    setUsers(result);
  };

  const handleSubmit = async (values: any) => {
    try {
      await ApiService.apiMainChangeRequestOwnerCreate({
        request_id: parseInt(props.requestId),
        user_id: values.user,
      });
      openNotificationWithIcon(
        "success",
        t("Request owner has been changed successfully")
      );
    } catch (e) {
      openNotificationWithIcon("error");
    }
    props.setFetch(props.fetch + 1);
    props.setVisible(false);
  };

  return (
    <Modal
      title={t("Handover request")}
      open={props.visible}
      onCancel={() => props.setVisible(false)}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item
          name="user"
          rules={[
            {
              required: true,
              message: t("Please input user's name or delete this field."),
            },
          ]}
          noStyle
        >
          <Select
            showSearch
            optionLabelProp="label"
            filterOption={false}
            style={{ width: "60%" }}
            onSearch={debounce(handleUserSearch, 300)}
            options={users}
            // notFoundContent={loading ? <Spin size="small" /> : null}
            placeholder={t("Type name..")}
          ></Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default HandoverModal;
